<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
    <div style="page-break-inside: avoid">
        <h5>{{title}}</h5>
        <table class="optionalComponentSectionTable">
            <tr style="font-weight: bold;">
                <td>Type</td>
                <td style="text-align:right;padding-right:5px;">No. of Devices</td>
                <td style="text-align:right;padding-right:5px;">Device Capacity (MW)</td>
                <td>Foundation Type</td>
            </tr>
            <tr *ngFor="let tt of tidalTurbines">
                <td>{{tt.type}}</td>
                <td style="text-align:right;padding-right:5px;">
                    <span *ngIf="tt.minNumberOfTurbines && !tt.exactNumberOfTurbines && !tt.maxNumberOfTurbines">more
                        than</span>
                    <span>{{tt.minNumberOfTurbines}}</span>
                    <span *ngIf="tt.minNumberOfTurbines && !tt.exactNumberOfTurbines && tt.maxNumberOfTurbines"> -
                    </span>
                    <span *ngIf="!tt.minNumberOfTurbines && !tt.exactNumberOfTurbines && tt.maxNumberOfTurbines">up to
                    </span>
                    <span>{{tt.maxNumberOfTurbines}}</span>
                    <span *ngIf="tt.exactNumberOfTurbines">{{tt.exactNumberOfTurbines}}</span>
                </td>
                <td style="text-align:right;padding-right:5px;">{{tt.deviceCapacity}}</td>
                <td>{{tt.foundationType}}</td>
            </tr>
        </table>
    </div>
</ng-template>

<ng-template #template_mobile let-title="title">
    <div style="page-break-inside: avoid">
        <h5>{{title}}</h5>
        <table class="optionalComponentSectionTable">
            <tr style="font-weight: bold;">
                <td>Type</td>
                <td style="text-align:right;padding-right:5px;">No. of Devices</td>
                <td style="text-align:right;padding-right:5px;">Device Capacity (MW)</td>
                <td>Foundation Type</td>
            </tr>
            <tr *ngFor="let tt of tidalTurbines">
                <td>{{tt.type}}</td>
                <td style="text-align:right;padding-right:5px;">
                    <span *ngIf="tt.minNumberOfTurbines && !tt.exactNumberOfTurbines && !tt.maxNumberOfTurbines">more
                        than</span>
                    <span>{{tt.minNumberOfTurbines}}</span>
                    <span *ngIf="tt.minNumberOfTurbines && !tt.exactNumberOfTurbines && tt.maxNumberOfTurbines"> -
                    </span>
                    <span *ngIf="!tt.minNumberOfTurbines && !tt.exactNumberOfTurbines && tt.maxNumberOfTurbines">up to
                    </span>
                    <span>{{tt.maxNumberOfTurbines}}</span>
                    <span *ngIf="tt.exactNumberOfTurbines">{{tt.exactNumberOfTurbines}}</span>
                </td>
                <td style="text-align:right;padding-right:5px;">{{tt.deviceCapacity}}</td>
                <td>{{tt.foundationType}}</td>
            </tr>
        </table>
    </div>
</ng-template>